import { BlockStack, Card, Grid, InlineStack, Text } from '@shopify/polaris';
import KnowledgeBanner from '../../../Asests/Images/knowledgebanner.png';
import Knowledgegroup from '../../../Asests/Images/knowledge base.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';

const KnowledgeBaseWelcome = () => {
    const { t } = useTranslation();
    return (
        <Card>
            <BlockStack gap="400">
                <BlockStack gap="300">
                    <BlockStack gap="100">
                        <Text variant="headingLg" as="h5">
                            {t("Welcome")}
                        </Text>
                        <Text tone="subdued" variant="headingMd" as="h6" fontWeight="medium">
                            {t("We’re glad you’re here.")}
                        </Text>
                    </BlockStack>
                    <img src={KnowledgeBanner} width='100%' />
                </BlockStack>
                <BlockStack gap="600">
                    <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>

                            <BlockStack gap="200">
                                <Text variant="bodyMd" as="p">
                                    {t("Knowledge Base, the centralized database of app functionalities, is designed to help you understand the app’s features in detail. It consists of relevant and helpful information based on each section that exists in the app.")}
                                </Text>
                                <Text variant="bodyMd" as="p">
                                    {t("Through this, you can use the app effectively and find the answers to your search queries.")}
                                </Text>
                            </BlockStack>


                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                            <InlineStack blockAlign="center" align='center'>
                                <img src={Knowledgegroup} width='100%' />
                            </InlineStack>
                        </Grid.Cell>
                    </Grid>
                    <BlockStack gap="300">
                        <Text variant="headingLg" as="h5">
                            {t("A Simple Guide")}
                        </Text>
                        <BlockStack gap="200">
                            <Text variant="bodyMd" as="p">
                                {t("We've organized topics like Listings, Product Linking, Orders, Settings, etc., into specific 'Sections.' Some sections will also be categorized into different groups to include in-depth answers to general queries. Each section has a knowledge base that explains its functionality, making it easy for you to understand what each section does when you explore it.")}
                            </Text>
                            <Text variant="bodyMd" as="p">
                                {t("This detailed narrative is meant to help your understanding of the app as you start using it for your business. Each section has sub-sections that explain the procedure, modalities, and functions, serving as a knowledge base in itself.")}
                            </Text>
                            <Text variant="bodyMd" as="p">
                                {t("For example, if you navigate to “Product Linking” in the Knowledge Base, you will find a detailed description of how it works. To break it down further, Product Linking will contain sub-sections such as, “Close Match”, “Linking Required”, “Linked” and “Deleted Listings”. Each of these will be explored in depth, leaving little room for doubt.")}
                            </Text>
                            <Text variant="bodyMd" as="p">
                                {t("Explore this Knowledge base and discover the possibilities of CedCommerce Amazon Shopify Channel. Feel free to contact our support team if you have any further questions.")}
                            </Text>
                        </BlockStack>
                    </BlockStack>
                </BlockStack>
            </BlockStack>
        </Card>
    );
}

export default KnowledgeBaseWelcome;